import { render } from "./Item.vue?vue&type=template&id=7dcd2c7b&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=7dcd2c7b&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcd2c7b"]])

export default __exports__